/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Track_View_Analytics1Inputs */

const en_coinvestments_track_view_analytics1 = /** @type {(inputs: Coinvestments_Track_View_Analytics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics`)
};

/**
* | output |
* | --- |
* | "Analytics" |
*
* @param {Coinvestments_Track_View_Analytics1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_track_view_analytics1 = /** @type {((inputs?: Coinvestments_Track_View_Analytics1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Track_View_Analytics1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_track_view_analytics1(inputs)
});
export { coinvestments_track_view_analytics1 as "coInvestments_track_view_analytics" }